import React, { useCallback, useState } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { Dropdown } from 'react-bootstrap'
import Label from 'components/general/Label';
import { useNavigateTo } from 'helpers/urlFriendly';
import { ALL_URL, isValidDate } from 'helpers/utils';
import { FilterEventTypes, createEventData, pagesWithDayFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';



export default function Selector_Day({ daysItems, page = "schedule" }) {
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    let params = useUrlFriendlyToParameters();
    let paramsURL = { ...params }

    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    const isScheduleAndAllDisciplines = () => {
        return page === 'schedule' && (!params["mirs_discipline"] || params["mirs_discipline"] === ALL_URL.ALL_DISC);
    }

    //const dispatch = useDispatch();
    let result = [];
    //result = data && data.competition_schedule.sort((a, b) => a.order - b.order);
    result = daysItems && daysItems?.competition_schedule?.sort((a, b) => new Date(a.date) - new Date(b.date));
    const options = result && result.map((item, index) => {
        return (
            <Dropdown.Item key={"Selector-Day-" + index} eventKey={item.date} >
                {item.date}
            </Dropdown.Item>
        )
    })

    const handleOnChange = (key) => {
        if (isValidDate(key) && paramsURL["mirs_event"] && paramsURL["mirs_event"] !== ALL_URL.ALL_EVENT) {
            paramsURL["mirs_event"] = ALL_URL.ALL_EVENT;
        }
        paramsURL["mirs_date"] = key
        if (pagesWithDayFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.DAY, key);
            publishFilterEvent(payload);
        }
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    const getToggleButtonText = () => {
        return isValidDate(paramsURL["mirs_date"]) ? paramsURL["mirs_date"] : 'LabelAllDays2'
    }

    return (
        <Dropdown onSelect={handleOnChange} className={"selectorContainer "} >
            <Dropdown.Toggle variant="success" id="selectorDays">
                {isValidDate(paramsURL["mirs_date"]) ? <span>{paramsURL["mirs_date"]}</span> :
                    <Label data={getToggleButtonText()} />}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {!isScheduleAndAllDisciplines() && <Dropdown.Item key="" eventKey="" >
                    <Label data={'LabelAllDays2'} />
                </Dropdown.Item>}
                {options}
            </Dropdown.Menu>
        </Dropdown>
    );
};



